"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosThemeBannerSchema = exports.APosThemeBannerModeSchema = exports.APosThemeBannerSlideSchema = void 0;
const zod_1 = require("zod");
const background_schema_1 = require("./background.schema");
const text_schema_1 = require("./text.schema");
/**
 * One banner slide. Background + text + optional CTA. Used by both static
 * (single slide) and carousel (many slides) modes.
 */
exports.APosThemeBannerSlideSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    background: background_schema_1.APosThemeBackgroundSchema,
    text: text_schema_1.APosThemeTextSchema,
    cta: zod_1.z
        .object({
        label: zod_1.z.string().max(40),
        action: zod_1.z.enum(['build-your-own', 'mood', 'none']).default('none'),
        moodId: zod_1.z.string().optional(),
    })
        .optional(),
});
exports.APosThemeBannerModeSchema = zod_1.z.enum(['static', 'carousel', 'playlist']);
/**
 * Top banner. `mode = playlist` reuses the existing pos-advertising playlist
 * the kiosk is already linked to (so the operator doesn't author content twice).
 */
exports.APosThemeBannerSchema = zod_1.z.object({
    enabled: zod_1.z.boolean().default(true),
    mode: exports.APosThemeBannerModeSchema.default('static'),
    slides: zod_1.z.array(exports.APosThemeBannerSlideSchema).default([]),
    rotationSeconds: zod_1.z.number().int().min(2).max(60).default(6),
    heightPercent: zod_1.z.number().int().min(15).max(50).default(30),
});
//# sourceMappingURL=banner.schema.js.map